export default "__VITE_ASSET__DVSSVcDy__"